export default __webpack_public_path__ + "static/media/WhereAreYouFrom_21.d708a615.png";